import React from "react";

import { DownlandOutline } from "antd-mobile-icons";
import { Modal } from "antd-mobile";

import modStyl from './Preview.module.scss'

type Props = {
  url: string;
  margin?: string;
}
const Preview: React.FC<Props> = ({margin, url})=> {
  const n2url = ()=> {
    window.wx.miniProgram.navigateTo({
      url: `/pages/preview/preview?urls=${url}`,
      fail(err: any) {
        Modal.alert("出错了", err)
        console.log(err)
      }
    })
  }
  if(/miniProgram/i.test(navigator.userAgent)) {
    return <button onClick={n2url} type="button" style={{margin}} className={modStyl.btn}><DownlandOutline/>下载协议</button>
  }
  return <a href={url} target="_blank" rel="noreferrer" style={{margin}} className={modStyl.btn}><DownlandOutline/>下载协议</a>
}

Preview.defaultProps = {
  margin: "0 0 0 5px"
}

export default Preview